export default [
  { to: 'behandlingsriktlinjer', title: 'Behandlingsriktlinjer' },
  { to: 'rutiner', title: 'Rutiner' },
  { to: 'acib', title: 'ACIB' },
  { to: 'ivpa', title: 'IVPA' },
  { to: 'helikopter', title: 'Helikopter' },
  { to: 'ekg', title: 'EKG' },
  { to: 'changelog', title: 'Ändringslogg' },
];
